import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TouchableHighlight,
} from "react-native";
import { shallowEqual, useSelector } from "react-redux";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import DropDown from "../../../commonComponents/Forms/dropDown";
import SingleOrderBuy from "../../event/childComponents/SingleOrderBuy";
import SingleOrderBuyIM from "../../event/childComponents/SingleOrderBuyIM";
import SingleOrderSell from "./SingleOrderSell";
import { globalFontStyle, globalStyle } from "../../../assets";
import Tooltip from "react-native-walkthrough-tooltip";
import { info } from "../../../utils/images";
import FastImage from "../../../common/FastImage";
import { isMobile } from "../../../utils/commonMethods";
import ProbeIcon from "../../../commonComponents/ProbeIcon";
import TitleComponent from "../../event/childComponents/TitleComponent";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import { convert } from "../../../locale/translateText";

const orderDesc = {
  cda: "A market order will be executed at best price available at the moment\n\n A limit order will be executed at price which is set by you",
  im: "A market order will be executed at best price available at the moment\n\n A limit order will be executed at price which is set by you",
};
const SingleOrder = ({
  eventDetails,
  eventInfo,
  isIm,
  isSellForm,
  setIsSellForm,
  orderStatus,
  orderBookSelectedData,
  invested_amount,
  closeSheet
}) => {
  const [toolTipVisible, setToolTipVisible] = useState(false);
  const [options, setOptions] = useState([
    {
      value: false,
      label: convert("Market"),
    },
    {
      value: true,
      label: convert("Limit"),
    },
  ]);
  //const [isSellForm, setIsSellForm] = useState(true);

  const onDropdownSelect = (value) => {
    if (value === isLimit) {
      return;
    } else if (value === true) {
      setIsLimit(true);
    } else if (value === false) {
      setIsLimit(false);
    }
  };

  let openType = useSelector(({ eventReducer }) => {
    return eventReducer?.eventDetails?.types;
  }, shallowEqual);

  var optionDefault;
  if (eventDetails?.probe?.tradeTypes) {
    optionDefault = eventDetails?.probe?.tradeTypes?.sell
      ? eventDetails?.probe?.tradeTypes?.sell
      : ["L"];
  } else if (openType) {
    optionDefault = openType;
  } else if (eventDetails?.tradeTypes) {
    optionDefault = eventDetails?.tradeTypes?.buy
      ? eventDetails?.tradeTypes?.buy
      : ["L"];
  } else if (eventDetails?.probe?.types) {
    optionDefault = eventDetails?.probe?.types;
  } else if (eventDetails?.types) {
    optionDefault = eventDetails?.types;
  } else {
    optionDefault = ["L"];
  }

  const [isLimit, setIsLimit] = useState(optionDefault[0] === "L");

  return (
    <View
      style={[
        {
          width: isMobile() ? Width.width : "auto",
          flex: 1,
          paddingBottom: 0,
        }
      ]}
    >
      <TitleComponent
        eventInfo={!isSellForm ? eventDetails : eventDetails?.probe}
      />
      <View
        style={{
          marginTop: -10,
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomWidth: 0.5,
          borderBottomColor: globalConfigurableData.borderColor,
          paddingHorizontal: 15,
          paddingTop: 15,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
          <TouchableOpacity
            style={[
              !isSellForm
                ? styles.selectedFormTypeBlock
                : styles.unSelectedFormTypeBlock,
            ]}
            onPress={() => setIsSellForm(true)}
          >
            <FormTextLabel
              labelStyles={
                !isSellForm
                  ? {
                      ...globalFontStyle.appFontSubHeading,
                    color: GlobalScreens.SingleOrder.switchTabSelectedColor,
                    }
                  : { ...globalFontStyle.appFontBody, color: globalConfigurableData.quaternaryTextColor1  }
              }
              label={"Buy"}
            />
          </TouchableOpacity>
          {eventDetails?.fantasy?.disablesell ? null : (
            <TouchableOpacity
              style={[
                isSellForm
                  ? styles.selectedFormTypeBlock
                  : styles.unSelectedFormTypeBlock,
              ]}
              onPress={() => setIsSellForm(false)}
            >
              <FormTextLabel
                labelStyles={
                  isSellForm
                    ? {
                        ...globalFontStyle.appFontSubHeading,
                      color: GlobalScreens.SingleOrder.switchTabSelectedColor,
                      }
                    : { ...globalFontStyle.appFontBody, color: globalConfigurableData.quaternaryTextColor1 }
                }
                label={"Sell"}
              />
            </TouchableOpacity>
          )}
        </View>
        <View
          style={{ flexDirection: "row", alignItems: "center", minHeight: 40 }}
        >
          <View
            style={{
              paddingBottom: 0,
              justifyContent: "center",
              marginRight: 5,
            }}
          >
            <Tooltip
              isVisible={toolTipVisible}
              contentStyle={[
                globalStyle.toolTipStyle,
                !isMobile() ? { flex: 1, minWidth: 150 } : {minWidth: 350},
              ]}
              content={
                <View style={{}}>
                  <FormTextLabel
                    labelStyles={{
                      ...globalFontStyle.appFontSubText,
                      color: globalConfigurableData.primaryTextColor1,
                    }}
                    label={!isLimit || isIm ? orderDesc.im : orderDesc.cda}
                  />
                </View>
              }
              placement="top"
              onClose={() => setToolTipVisible(false)}
              showChildInTooltip={false}
              disableShadow={true}
              backgroundColor={"rgba(0,0,0)"}
              allowChildInteraction={true}
            >
              <TouchableHighlight
                activeOpacity={0.8}
                style={globalStyle.infoIcon}
                onPress={() => setToolTipVisible(true)}
              >
                <FastImage style={styles.infoStyle} source={globalConfigurableData?.info()} />
              </TouchableHighlight>
            </Tooltip>
          </View>

          {isIm || (optionDefault.length === 1 && optionDefault[0] === "M") ? (
              <FormTextLabel labelStyles={{ paddingBottom: 0, color: globalConfigurableData.primaryTextColor1 }} label={"Market"} />
          ) : optionDefault.length === 1 && optionDefault[0] === "L" ? (
              <FormTextLabel labelStyles={{ paddingBottom: 0, color: globalConfigurableData.primaryTextColor1 }} label={"Limit"} />
          ) : (
            <View style={{ paddingBottom: 0, marginBottom: 0 }}>
              <DropDown
                selectedData={
                  optionDefault[0] === "L" ? options[1] : options[0]
                }
                onValueChange={onDropdownSelect}
                pickerlist={options}
                isLeftIcon={false}
                isMarketDropdown={true}
              />
            </View>
          )}
        </View>
      </View>
      {isSellForm ? (
        <SingleOrderSell
          eventDetails={eventDetails}
          isLimit={isLimit}
          orderStatus={orderStatus}
          closeSheet={closeSheet}
        />
      ) : !isIm ? (
        <SingleOrderBuy
          eventDetails={{
            ...eventDetails,
            newYCP: eventDetails?.newYCP ? eventDetails?.newYCP : 50,
            newNCP: eventDetails?.newNCP ? eventDetails?.newNCP : 50,
          }}
          orderStatus={orderStatus}
          orderBookSelectedData={orderBookSelectedData}
          invested_amount={invested_amount}
          isLimit={isLimit}
          closeSheet={closeSheet}
        />
      ) : (
        <SingleOrderBuyIM
          eventDetails={eventDetails}
          orderStatus={orderStatus}
          orderBookSelectedData={orderBookSelectedData}
          invested_amount={invested_amount}
          closeSheet={closeSheet}
        />
      )}
    </View>
  );
};

export default SingleOrder;

const styles = StyleSheet.create({
  selectedFormTypeBlock: {
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingBottom: 10,
    borderBottomColor: GlobalScreens.SingleOrder.switchTabSelectedColor,
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomStartRadius: 2,
    borderBottomEndRadius: 2,
  },
  unSelectedFormTypeBlock: {
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingBottom: 10,
    borderBottomColor: GlobalScreens.SingleOrder.switchTabUnselectedBorderColor,
  },
  eventTitle: {
    flex: 1,
    marginLeft: 15,
    alignSelf: "center",
  },
  infoStyle: {
    width: 15,
    height: 15,
  },
});
